import type {FetchTasksQuery, TasksIndex} from '../../http';
import {fetchTasks} from '../../http';
import {useInfiniteQuery, UseInfiniteQueryOptions} from 'react-query';

type InfiniteTasksQuery = Omit<FetchTasksQuery, 'page'>;

const defaultQuery: InfiniteTasksQuery = {};

export function useInfiniteFetchTasks(
	query?: InfiniteTasksQuery,
	options?: UseInfiniteQueryOptions<TasksIndex>,
) {
	const q = query ?? defaultQuery;

	return useInfiniteQuery<TasksIndex>({
		queryKey: ['tasks', 'infinite', q],
		queryFn: async ({pageParam = 1, signal}) => {
			const {data} = await fetchTasks({...q, page: pageParam}, signal);

			return data;
		},
		getNextPageParam: (lastPage) => {
			const currentPage = lastPage.meta?.current ?? 1;
			const lastPageNumber = lastPage.meta?.last ?? currentPage;

			if (currentPage >= lastPageNumber) return undefined;

			return currentPage + 1;
		},
		...options,
	});
}
